import React, { createContext, useContext, useEffect, useState } from 'react';
type CountdownValue = {
  secondsLeft: number;
  label: string;
};
const START_SECONDS = 14 * 60 + 8;
const STORAGE_KEY = 'makerlab-offer-ends';
const CountdownContext = createContext<CountdownValue>({
  secondsLeft: START_SECONDS,
  label: '14:08'
});
export function CountdownProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [secondsLeft, setSecondsLeft] = useState(START_SECONDS);
  useEffect(() => {
    let endsAt = Number(sessionStorage.getItem(STORAGE_KEY));
    if (!endsAt || endsAt < Date.now()) {
      endsAt = Date.now() + START_SECONDS * 1000;
      sessionStorage.setItem(STORAGE_KEY, String(endsAt));
    }
    const tick = () => {
      setSecondsLeft(Math.max(0, Math.round((endsAt - Date.now()) / 1000)));
    };
    tick();
    const id = window.setInterval(tick, 1000);
    return () => window.clearInterval(id);
  }, []);
  return <CountdownContext.Provider value={{
    secondsLeft,
    label: formatTime(secondsLeft)
  }} data-id="element-272" data-mp="1x1ckmoyk0gmp">
      {children}
    </CountdownContext.Provider>;
}
export function useCountdown() {
  return useContext(CountdownContext);
}
function formatTime(total: number) {
  const m = Math.floor(total / 60);
  const s = total % 60;
  return `${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
}